export enum SystemTeams {
  Users = 'Users',
  Owners = 'Owners'
}